import { render, staticRenderFns } from "./CustomerTouchPoint.vue?vue&type=template&id=c41c1c9e&scoped=true&"
import script from "./CustomerTouchPoint.vue?vue&type=script&lang=ts&"
export * from "./CustomerTouchPoint.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerTouchPoint.vue?vue&type=style&index=0&id=c41c1c9e&prod&scoped=true&lang=css&"
import style1 from "./CustomerTouchPoint.vue?vue&type=style&index=1&id=c41c1c9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41c1c9e",
  null
  
)

export default component.exports